import { useMutation, gql } from '@apollo/client';
import {
  DeletarTurmaMutation,
  DeletarTurmaMutationVariables,
} from './__generated__/DeletarTurmaMutation';

const DELETAR_TURMA_MUTATION = gql`
  mutation DeletarTurmaMutation($id_turma: Int!) {
    deletarTurma(id_turma: $id_turma) {
      id_turma
    }
  }
`;

const useDeletarTurmaMutation = () => {
  return useMutation<DeletarTurmaMutation, DeletarTurmaMutationVariables>(DELETAR_TURMA_MUTATION);
};

export { useDeletarTurmaMutation };
